var LabelButton     = require("./LabelButton");
var $               = require("jquery");


var defaultOptions = $.extend({}, LabelButton.DEFAULT_OPTIONS, {
    /* Перезапишем label компонента чтоб как-то отличать Button'ы друг от друга */
    label: 'DistanceButton'
});

var DistanceButton = LabelButton.extend({

    /**
     *
     */
    initialize: function(options){
        var that = this;
        options = options || {};
        options = $.extend({}, defaultOptions, options);

        that._map = undefined;
        that._measurement = undefined;

        DistanceButton.__super__.initialize.call(that, options);

        that.getContainer()
            // .addClass('button-distance')
            .on('click', function(e){
                that._measurement.changeInteraction('distance');
            });
    },

    /**
     *
     */
    onAdd: function(view){
        var that = this;

        that._map = view.getMap();
        that._measurement = view.getMeasurement();
        that._measurement.on('measureChanged', function(event){
            if (event.measureType == 'distance') {
                that.getContainer().addClass('active');
            } else {
                that.getContainer().removeClass('active');
            }
        })
    }
});

module.exports = DistanceButton;


//////////////////
// WEBPACK FOOTER
// ./src/View/Widget/DistanceButton.js
// module id = 205
// module chunks = 0